import React from "react"
import { Main } from "../../styles/Container"
import Spinner from "@nvdb-rapport/shared/src/components/Spinner"
import { Heading2 } from "../../styles/Heading"

export default function Loading() {
  return (
    <Main
      style={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        marginTop: "10%",
      }}
    >
      <Spinner />
      <Heading2>Laster inn</Heading2>
    </Main>
  )
}
